import type { AppointmentDTO } from 'src/types/dto/appointment.dto';

import { convertToTimezone } from 'src/utils/timezone';

const resolveAppointmentTimezone = (appointment: AppointmentDTO) =>
  appointment.timezoneId?.trim() ||
  appointment.inspector?.timezoneId?.trim() ||
  appointment.activity?.site?.timezoneId?.trim() ||
  'UTC';

export const formatCreateAvailabilityLabelFromAppointment = (
  appointment?: AppointmentDTO
): string | null => {
  if (!appointment?.from) {
    return null;
  }

  const local = convertToTimezone(appointment.from, resolveAppointmentTimezone(appointment));
  return local.isValid() ? local.format('DD MMM YY') : null;
};
